import { Camera, Clapperboard, Layers, Sparkles, Zap } from "lucide-react";

export const WHATSAPP_DISPLAY = "(21) 98029-5490";
export const WHATSAPP_URL = process.env.REACT_APP_WHATSAPP_URL;

export const services = [
  {
    id: "edicao",
    name: "Edição de Vídeo",
    tag: "O essencial, muito bem feito",
    price: "a partir de R$ 19,90",
    icon: Clapperboard,
    advantages: ["Cortes com ritmo e intenção", "Transições simples e limpas", "Resolução simples", "Vídeos de 40 a 50 segundos"],
    modalIntro: "A porta de entrada para elevar o seu conteúdo: edição objetiva, com resolução simples e transições leves, para vídeos de 40 a 50 segundos.",
    modalBullets: ["Resolução simples", "Transições simples", "Duração de 40 a 50 segundos", "Valor base de R$ 19,90"],
    modalNote: "Reparos, ajustes e acréscimos no projeto podem alterar o valor final — sempre combinados diretamente com você, com total transparência, antes de qualquer mudança.",
  },
  {
    id: "shortcuts",
    name: "Shortcuts",
    tag: "Sua rotina em vídeos incríveis",
    price: "R$ 29,90",
    icon: Zap,
    advantages: ["Vídeos curtos no estilo vlog", "Mais rapidez na edição", "Mais criatividade nos seus vídeos", "Conexão com o seu público"],
    modalIntro: "Shortcuts são atalhos práticos que capturam momentos reais do seu dia a dia — perfeitos para criar vídeos envolventes no estilo vlog, mostrando sua rotina, bastidores, processos e tudo o que faz parte da sua história.",
    modalBullets: ["Edição de vídeos curtos de rotina, bastidores e vlog", "Mais rapidez na edição", "Mais criatividade nos seus vídeos", "Melhores resultados para o seu conteúdo", "Conexão com o seu público", "Perfeito para manhã produtiva, bastidores, dia a dia na rua, planejamento e fechamento"],
  },
  {
    id: "beta",
    name: "Pacote Beta",
    tag: "Para começar com qualidade profissional",
    price: "R$ 190/mês",
    icon: Layers,
    advantages: ["4 vídeos por semana", "Resolução tratada em HD", "Transições suaves", "Legendas simples"],
    modalIntro: "O pacote ideal para quem está começando e quer constância com qualidade profissional, sem abrir mão do cuidado em cada corte.",
    modalBullets: ["4 vídeos por semana, seguindo cronograma", "Vídeos de até 1m30", "Resoluções tratadas em HD", "Transições suaves", "Legendas simples", "Sem inteligência artificial", "Sem trilha sonora — ideal para vídeos falados", "Capa simples para Reels e até 4 stories criativos", "Entrega em até 48h, conforme a demanda"],
  },
  {
    id: "plus",
    name: "Pacote Plus",
    tag: "Para quem quer mais impacto e resultado",
    price: "R$ 290/mês",
    icon: Sparkles,
    advantages: ["6 vídeos por semana", "Resolução 4K e Full HD", "Legendas estilizadas", "IA aplicada e trilha sonora"],
    modalIntro: "A experiência completa: mais volume, mais refinamento e recursos avançados para o seu conteúdo se destacar de verdade.",
    modalBullets: ["6 vídeos por semana, seguindo cronograma", "Vídeos de até 2m30", "Resoluções aprimoradas em 4K e Full HD", "Legendas dinâmicas, estilizadas e personalizadas", "Inteligência artificial aplicada à edição", "Trilha sonora incluída", "Capa personalizada para Reels e até 6 stories criativos", "Entrega em até 12h"],
  },
  {
    id: "capas",
    name: "Capas de Reels",
    tag: "Design que chama atenção",
    price: "R$ 10 · 2 por R$ 15",
    icon: Camera,
    advantages: ["Uma capa profissional por R$ 10", "Duas capas por R$ 15", "Entrega rápida e de qualidade"],
    modalIntro: "Uma boa capa agrega mais valor e capta melhor a atenção do seu público. É o primeiro contato visual do seu conteúdo — e ela precisa ser irresistível.",
    modalBullets: ["Design profissional e personalizado", "Mais cliques e mais visualizações", "Profissionalismo no seu perfil", "1 capa por R$ 10 ou 2 capas por R$ 15"],
    hasSundayPromo: true,
  },
];
